import type { NavSectionProps } from 'src/components/nav-section';

import { useQuery } from '@tanstack/react-query';

import API from 'src/services/API';
import { useSelectedTenant } from 'src/layouts/provider';

import { isHqTenantCode } from 'src/auth/utils';

import { menusToNavData } from '../utils/menu-to-nav-data';

// ----------------------------------------------------------------------

type NavScope = 'dashboard' | 'hq';

/** 拉取当前用户在当前租户下可见的导航菜单 */
export function useMeNavData(scope?: NavScope): NavSectionProps['data'] {
  const { tenantId, membership, loading: tenantLoading } = useSelectedTenant();
  const isHqTenant = isHqTenantCode(membership?.tenantCode);
  const canFetchHq = scope !== 'hq' || isHqTenant;

  const { data, isLoading } = useQuery({
    queryKey: ['me', 'menus', scope, tenantId],
    queryFn: async () => {
      const res = await API.MeMenu.MeMenuControllerGetMyMenusV1({ scope: scope! });
      return menusToNavData(res.data?.data ?? []);
    },
    enabled: !!scope && !!tenantId && !tenantLoading && canFetchHq,
  });

  if (!scope || tenantLoading || isLoading || !canFetchHq) {
    return [];
  }

  return data ?? [];
}
